import { render, staticRenderFns } from "./ResetKey.vue?vue&type=template&id=350893a9&scoped=true&"
import script from "./ResetKey.vue?vue&type=script&lang=js&"
export * from "./ResetKey.vue?vue&type=script&lang=js&"
import style0 from "./ResetKey.vue?vue&type=style&index=0&id=350893a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350893a9",
  null
  
)

export default component.exports